import Button from '@/components/Button';
import SearchForm from '@/components/search/SearchForm';
import useSearch from '@/components/search/useSearch';
import ProductCategoryTable from '@/modules/product/components/ProductCategoryTable';
import { ProductCategoryAddPath } from '@/modules/product/paths';
import SettingsHeader from '@/modules/settings/components/SettingsHeader';
import { FolderIcon } from '@heroicons/react/24/outline';
import { PlusIcon } from '@heroicons/react/24/solid';

const ProductCategoryCategory = () => {
  const { searchQuery, page, handleSearchSubmit, handlePageChange, setSearchQuery } = useSearch();

  return (
    <>
      <SettingsHeader title="Product Categories" icon={<FolderIcon className="w-6 h-6" />}>
        <Button
          to={ProductCategoryAddPath}
          icon={<PlusIcon className="h-5 w-5 mr-1" />}
          variant="secondary"
        >
          Add Product Category
        </Button>
      </SettingsHeader>

      <SearchForm
        onSubmit={handleSearchSubmit}
        onChange={setSearchQuery}
        value={searchQuery}
        placeholder="Search by name"
      />

      <ProductCategoryTable searchQuery={searchQuery} page={page} onChangePage={handlePageChange} />
    </>
  );
};

export default ProductCategoryCategory;
